export const HEADING = "Change car rental";
export const SUBHEADING =
  "This rental is managed by the provider. To change this rental, please visit the carrier website to manage your booking.";
export const SUBHEADING_AGENT =
  "To change this car rental, please contact our customer support team and someone will assist you. ";
export const CONTACT_SUPPORT = "Contact support";
export const CANCEL = "Cancel";
export const PROVIDER_CTA = "Continue to the provider website";
